import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import PendingOrders from "./PendingOrders";
import InProgressOrders from "./InProgressOrders";
import FinishedOrders from "./FinishedOrders";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderById } from "../../redux/ShowOrderIdSlice";
import { fetchOrdersByStatus } from "../../redux/orderStatusSlice";
import ServiceRequestsPending from "./ServiceRequestsPending";
import ServiceRequest from "./ServiceRequest";
import { Button, Carousel, Modal } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import InProgressOrder from "./InProgressOrder";
import { Link } from "react-router-dom";
import UnderGuaranteeOrder from "./UnderGuaranteeOrder";
import ServiceRequestFinished from "./ServiceRequestFinished";
import { useTranslation } from "react-i18next";

const Orders = ({ filter }) => {
  
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [selectedStatus, setSelectedStatus] = useState("pending");
  const [selectedStatusProg, setSelectedStatusProg] = useState("progress");
  const [selectedStatusFin, setSelectedStatusFin] = useState("finished");
  const [selectedStatusWarranty, setSelectedStatusWarranty] =
    useState("warranty");

  const [orders, setOrders] = useState([]);
  const [ordersProg, setOrdersProg] = useState([]);
  const [ordersFin, setOrdersFin] = useState([]);
  const [ordersWarranty, setOrdersWarranty] = useState([]);

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        const result = await dispatch(
          fetchOrdersByStatus(selectedStatus)
        ).unwrap();

        setOrders(result || []);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, [selectedStatus, dispatch]);

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        const result = await dispatch(
          fetchOrdersByStatus(selectedStatusProg)
        ).unwrap();

        setOrdersProg(result || []);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, [selectedStatusProg, dispatch]);

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        const result = await dispatch(
          fetchOrdersByStatus(selectedStatusFin)
        ).unwrap();

        setOrdersFin(result || []);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, [selectedStatusFin, dispatch]);

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        const result = await dispatch(
          fetchOrdersByStatus(selectedStatusWarranty)
        ).unwrap();

        setOrdersWarranty(result || []);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, [selectedStatusWarranty, dispatch]);

  const onChange = (key) => {
    console.log(key);
  };

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const formatDateTime = (dateString) => {
    const dateObject = new Date(dateString);
    const day = String(dateObject.getDate()).padStart(2, "0");
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const year = dateObject.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    const hours = String(dateObject.getHours()).padStart(2, "0");
    const minutes = String(dateObject.getMinutes()).padStart(2, "0");

    const formattedTime = `${hours}:${minutes}`;

    return { formattedDate, formattedTime };
  };

  const items = [
    {
      key: "1",
      label: <span>{t("Pending")}</span>,
      children: (
        <div>
          {filter === "all" && (
            <>
              {/* Service Requests */}
              <div className="mb-14 PendingOrders">
                <div>
                  <h2 className="text-[#14294F] max-lg:text-xl lg:text-2xl font-semibold ml-8 max-lg:ml-4 mb-3 mt-5 leading-relaxed">
                    {t("Service Requests")}
                  </h2>
                  <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4">
                    {orders?.data?.length > 0 ? (
                      orders?.data?.map((orderr, index) => {
                        const { formattedDate, formattedTime } = formatDateTime(
                          orderr.updated_at
                        );
                        return (
                          <ServiceRequestsPending
                            key={index}
                            idOrder={orderr.id}
                            date={orderr.date}
                            time={orderr.time}
                            dateCreated={formattedDate}
                            timeCreated={formattedTime}
                            image={`https://service.samoolah.com/${orderr.category.icon}`}
                          />
                        );
                      })
                    ) : (
                      <p className="text-center text-2xl max-lg:text-lg text-[#FE9B71] col-span-2 lg:mt-7 pt-7">
                        {t("No Service requests")}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Store Orders */}
              <div className="mb-14 PendingOrders">
                <div>
                  <h2 className="text-[#14294F] max-lg:text-xl lg:text-2xl font-semibold ml-8 max-lg:ml-4 mb-3 mt-5 leading-relaxed">
                    {t("Store Orders")}
                  </h2>
                  <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4">
                    <p className="text-center text-2xl max-lg:text-lg text-[#FE9B71] col-span-2 lg:mt-7 pt-7">
                      {t("No store orders")}
                    </p>
                  </div>
                </div>
              </div>
            </>
          )}

          {filter === "Service_requests" && (
            <div className="mb-14 PendingOrders">
              <div>
                <h2 className="text-[#14294F] max-lg:text-xl lg:text-2xl font-semibold ml-8 max-lg:ml-4 mb-3 mt-5 leading-relaxed">
                  {t("Service Requests")}
                </h2>
                <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4">
                  {orders?.data?.length > 0 ? (
                    orders?.data?.map((orderr, index) => {
                      const { formattedDate, formattedTime } = formatDateTime(
                        orderr.updated_at
                      );
                      return (
                        <ServiceRequestsPending
                          key={index}
                          idOrder={orderr.id}
                          date={orderr.date}
                          time={orderr.time}
                          dateCreated={formattedDate}
                          timeCreated={formattedTime}
                          image={`https://service.samoolah.com/${orderr.category.icon}`}
                        />
                      );
                    })
                  ) : (
                    <p className="text-center text-2xl max-lg:text-lg text-[#FE9B71] col-span-2 lg:mt-7 pt-7">
                      {t("No Service requests")}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}

          {filter === "Store_orders" && (
            <div className="mb-14 PendingOrders">
              <div>
                <h2 className="text-[#14294F] max-lg:text-xl lg:text-2xl font-semibold ml-8 max-lg:ml-4 mb-3 mt-5 leading-relaxed">
                  {t("Store Orders")}
                </h2>
                <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4">
                  <p className="text-center text-2xl max-lg:text-lg text-[#FE9B71] col-span-2 lg:mt-7 pt-7">
                    {t("No store orders")}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      key: "2",
      label: <span className="custom-tab-label">{t("In Progress")}</span>,
      children: (
        <div className="mb-14 InProgressOrders">
          {filter === "all" && (
            <>
              <div>
                <div className="flex items-center justify-between">
                  <h2 className="text-[#14294F] max-lg:text-xl lg:text-2xl font-semibold mb-3 mt-5 leading-relaxed">
                    {t("Store Orders")}
                  </h2>
                </div>

                {/* <Carousel arrows infinite={false}>
                  <div>
                    <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4">
                      <InProgressOrder />
                      <InProgressOrder />
                    </div>
                  </div>
                  <div>
                    <h3>2</h3>
                  </div>
                </Carousel> */}

                <p className="text-center text-2xl text-[#FE9B71] mt-7 pt-7">
                  {t("No store orders")}
                </p>
              </div>

              <div className="mt-14">
                <div className="flex items-center justify-between">
                  <h2 className="text-[#14294F] max-lg:text-xl lg:text-2xl font-semibold mb-3 mt-5 leading-relaxed">
                    {t("Service Requests")}
                  </h2>
                </div>

                {ordersProg?.data?.length > 0 ? (
                  <Carousel arrows infinite={false}>
                    {chunkArray(ordersProg?.data || [], 2).map(
                      (chunk, chunkIndex) => (
                        <div key={chunkIndex}>
                          <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-7"
                          dir={language == "en" ? "lrt" : "rtl"}>
                            {chunk.map((orderr, index) => (
                              <ServiceRequest
                                key={index}
                                idOrder={orderr.id}
                                date={orderr.date}
                                time={orderr.time}
                                image={`https://service.samoolah.com/${orderr.category.icon}`}
                                status={
                                  orderr.status == "on_way"
                                    ? language == "en" ? "On the way" : "في الطريق"
                                    : orderr.status == "arrived"
                                    ? language == "en" ? "Arrived" : "وصل"
                                    : orderr.status == "cost_arrangement"
                                    ? language == "en" ? "Cost arrangement" : "ترتيب التكلفة"
                                    : orderr.status == "acceptperview"
                                    ? language == "en" ? "Accept preview" : "تم قبول المعاينة"
                                    : orderr.status == "rated"
                                    ? language == "en" ? "Rated" : "تم تقييمه"
                                    : orderr.status == "scaned_qr"
                                    ? language == "en" ? "Pricing" : "التسعير"
                                    : language == "en" ? "Preparing" : "التحضير"
                                }
                              />
                            ))}
                          </div>
                        </div>
                      )
                    )}
                  </Carousel>
                ) : (
                  <p className="text-center text-2xl text-[#FE9B71] mt-7 pt-7">
                    {t("No Service requests")}
                  </p>
                )}
              </div>
            </>
          )}

          {filter === "Service_requests" && (
            <div className="mt-14">
              <div className="flex items-center justify-between">
                <h2 className="text-[#14294F] max-lg:text-xl lg:text-2xl font-semibold mb-3 mt-5 leading-relaxed">
                  {t("Service Requests")}
                </h2>
              </div>

              {ordersProg?.data?.length > 0 ? (
                <Carousel arrows infinite={false}>
                  {chunkArray(ordersProg?.data || [], 2).map(
                    (chunk, chunkIndex) => (
                      <div key={chunkIndex}>
                        <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4" 
                        dir={language == "en" ? "lrt" : "rtl"}>
                          {chunk.map((orderr, index) => (
                            <ServiceRequest
                              key={index}
                              idOrder={orderr.id}
                              date={orderr.date}
                              time={orderr.time}
                              image={`https://service.samoolah.com/${orderr.category.icon}`}
                              status={
                                orderr.status == "on_way"
                                  ? language == "en" ? "On the way" : "في الطريق"
                                  : orderr.status == "arrived"
                                  ? language == "en" ? "Arrived" : "وصل"
                                  : orderr.status == "cost_arrangement"
                                  ? language == "en" ? "Cost arrangement" : "ترتيب التكلفة"
                                  : orderr.status == "acceptperview"
                                  ? language == "en" ? "Accept preview" : "تم قبول المعاينة"
                                  : orderr.status == "rated"
                                  ? language == "en" ? "Rated" : "تم تقييمه"
                                  : orderr.status == "scaned_qr"
                                  ? language == "en" ? "Pricing" : "التسعير"
                                  : language == "en" ? "Preparing" : "التحضير"
                              }
                            />
                          ))}
                        </div>
                      </div>
                    )
                  )}
                </Carousel>
              ) : (
                <p className="text-center text-2xl text-[#FE9B71] mt-7 pt-7">
                  {t("No Service requests")}
                </p>
              )}
            </div>
          )}

          {filter === "Store_orders" && (
            <div>
              <div className="flex items-center justify-between">
                <h2 className="text-[#14294F] max-lg:text-xl lg:text-2xl font-semibold mb-3 mt-5 leading-relaxed">
                  {t("Store Orders")}
                </h2>
              </div>

              {/* <Carousel arrows infinite={false}>
                <div>
                  <div className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4">
                    <InProgressOrder />
                    <InProgressOrder />
                  </div>
                </div>
                <div>
                  <h3>2</h3>
                </div>
              </Carousel> */}
              <p className="text-center text-2xl text-[#FE9B71] mt-7 pt-7">
                {t("No store orders")}
              </p>
            </div>
          )}
        </div>
      ),
    },
    {
      key: "3",
      label: <span>{t("Finished")}</span>,
      children: (
        <div className="mb-14 InProgressOrders">
          <div>
            <div className="flex items-center justify-between">
              <h2 className="text-[#14294F] max-lg:text-xl lg:text-2xl font-semibold mb-3 mt-5 leading-relaxed">
                {t("Under Guarantee")}
              </h2>

              <Link
                to="/allordersunderguarantee"
                className="flex items-center text-[#FE9B71] text-xl font-semibold"
              >
                {language == "en" ? (
                  <>
                    {t("View All")}
                    <RightOutlined className="ml-3 max-lg:ml-2 font-bold" />
                  </>
                ) : (
                  <>
                    {t("View All")}
                    <LeftOutlined className="mr-3 max-lg:mr-2 font-bold" />
                  </>
                )}
              </Link>
            </div>

            {ordersWarranty?.data?.length > 0 ? (
              <Carousel arrows infinite={false}>
                {chunkArray(ordersWarranty?.data || [], 2).map(
                  (chunk, chunkIndex) => (
                    <div key={chunkIndex}>
                      <div
                        className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4"
                        dir={language == "en" ? "lrt" : "rtl"}
                      >
                        {chunk.map((orderr, index) => (
                          <UnderGuaranteeOrder
                            key={index}
                            idOrder={orderr.id}
                            orderStatus={orderr.status}
                            date={orderr.date}
                            time={orderr.time}
                            image={`https://service.samoolah.com/${orderr.category.icon}`}
                          />
                        ))}
                      </div>
                    </div>
                  )
                )}
              </Carousel>
            ) : (
              <p className="text-center text-2xl text-[#FE9B71] mt-7 pt-7">
                {t("No Service requests")}
              </p>
            )}
          </div>

          <div className="mt-14">
            <div className="flex items-center justify-between">
              <h2 className="text-[#14294F] max-lg:text-xl lg:text-2xl font-semibold mb-3 mt-5 leading-relaxed">
                {t("All Orders")}
              </h2>

              <Link
                to="/allOrders"
                className="flex items-center text-[#FE9B71] text-xl font-semibold"
              >
                {language == "en" ? (
                  <>
                    {t("View All")}
                    <RightOutlined className="ml-3 max-lg:ml-2 font-bold" />
                  </>
                ) : (
                  <>
                    {t("View All")}
                    <LeftOutlined className="mr-3 max-lg:mr-2 font-bold" />
                  </>
                )}
              </Link>
            </div>

            {ordersFin?.data?.length > 0 ? (
              <Carousel arrows infinite={false}>
                {chunkArray(ordersFin?.data || [], 2).map(
                  (chunk, chunkIndex) => (
                    <div key={chunkIndex}>
                      <div
                        className="grid grid-cols-2 gap-10 max-xl:grid-cols-1 mb-10 mx-12 max-lg:mx-4"
                        dir={language == "en" ? "lrt" : "rtl"}
                      >
                        {chunk.map((orderr, index) => (
                          <ServiceRequestFinished
                            key={index}
                            idOrder={orderr.id}
                            orderStatus={orderr.status}
                            // orderStatus="completed"
                            date={orderr.date}
                            time={orderr.time}
                            image={`https://service.samoolah.com/${orderr.category.icon}`}
                          />
                        ))}
                      </div>
                    </div>
                  )
                )}
              </Carousel>
            ) : (
              <p className="text-center text-2xl text-[#FE9B71] mt-7 pt-7">
                {t("No Service requests")}
              </p>
            )}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div
        className={`loadingTab ${
          language == "ar" && "loadingTab_ar"
        } px-20 max-lg:px-5`}
      >
        <Tabs
          defaultActiveKey="1"
          items={items}
          onChange={onChange}
          tabBarStyle={{
            textAlign: language === "en" ? "left" : "right",
          }}
        />
      </div>
    </div>
  );
};

export default Orders;
